export const formatLatency = (value: number) => {
    if (value <= 99) {
        return `${value}ms`;
    }

    const seconds = Math.round((value / 1000) * 10) / 10;
    return `${seconds}s`;
};
